<template>
  <div class="head flex flex-between flex-middle">
    <div class="head-left flex flex-column flex-between">
      <el-image
        class="head-left-icon"
        :src="titleMap[headType].icon"
        fit="cover"
      ></el-image>
      <div class="head-left-title">{{ titleMap[headType].title }}</div>
      <div class="head-left-enTitle">{{ titleMap[headType].enTitle }}</div>
    </div>
    <div class="head-right pointer" @click="$emit('entry')">
      {{ titleMap[headType].btn }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      titleMap: {
        1: {
          title: "入驻企业",
          enTitle: "Settled Enterprise",
          icon: this.$oss("home/news/settled_icon1.png"),
          btn: "立即入驻",
        },
        2: {
          title: "入驻实验室",
          enTitle: "Settled Laboratory",
          icon: this.$oss("home/news/settled_icon2.png"),
          btn: "立即入驻",
        },
        3: {
          title: "最新需求",
          enTitle: "Latest Demand",
          icon: this.$oss("home/news/settled_icon3.png"),
          btn: "发布需求",
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";
.head {
  width: 380px;
  height: 116px;
  background: url($oss-url + "home/news/settled_bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 16px 16px 12px 16px;
  margin-bottom: 16px;
  .head-left {
    &-icon {
      width: 32px;
      height: 32px;
    }
    &-title {
      font-size: 18px;
      color: #333;
      font-weight: 500;
      padding: 8px 0;
    }
    &-enTitle {
      font-weight: 300;
      color: #333333;
      font-size: 13px;
    }
  }
  .head-right {
    // color: #fff;
    color: #004ac1;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    // background: $theme-color;
    border: 0.5px solid #004ac1;
    border-radius: $border-radius;
  }
}
</style>
